/**
 * @module app.core
 */

import { autoinject, bindable, bindingMode } from "aurelia-framework";
import { ICustomEditModel } from "./custom-edit";
import { ICustomFieldDefinition, ICustomFieldDefinitionContainer, ICustomFieldDefinitionsTextCollectionIndexer } from "../interfaces";

@autoinject
export class CustomEditText {

    @bindable({ defaultBindingMode: bindingMode.twoWay })
    public value: string | null = null;

    @bindable({ defaultBindingMode: bindingMode.oneWay })
    public container: ICustomFieldDefinitionContainer | null = null;

    @bindable({ defaultBindingMode: bindingMode.oneWay })
    public definition: ICustomFieldDefinition | null = null;

    constructor() { }

    protected async activate(model: ICustomEditModel): Promise<void> {
        if(model) {
            this.container = model.container;
            this.definition = model.definition;
            const texts = (this.container.text || null) as ICustomFieldDefinitionsTextCollectionIndexer | null;
            if(texts && this.definition.property && this.definition.property.field) {
                this.value = texts[this.definition.property.field] || null;
            }
        }
    }

    protected valueChanged() {
        M.updateTextFields();
        if(this.container && this.definition && this.definition.property && this.definition.property.type && this.definition.property.field) {
            const texts = (this.container.text || null) as ICustomFieldDefinitionsTextCollectionIndexer | null;
            if(texts) {
                texts[this.definition.property.field] = this.value || null;
            }
        }
    }

}
